export const URL = {
  RATES_URL: '/rates',
  USERS_URL: '/users',
  USERS_SETTINGS_URL: '/settings/user/index',
  ROLES_URL: '/roles',
  STATUS_URL: '/status',
  NOW_URL: '/now',
  EVENTS_URL: '/events',
  AVAILABLE_TIME_URL: '/availableTime',
  EVENTS_TYPE_URL: 'eventTypes',
  EVENTS_UPDATE_URL: '/updateEventPopUp/multipleCalendar',
  AGENT_EVENTS_UPDATE_URL: '/updateEventPopUp',
  EVENTS_CALENDAR_URL: '/events/multipleCalendar',
  EVENTS_CHECK_CUSTOMER: '/check-agent-customer',
  ADDRESSBOOK: '/addressbook',
  OFFDATES_URL: '/offdates',
  TELABOOK_ADDRESSBOOKS_URL: '/address-books',
  GOOGLE_PLACES_API: 'https://maps.googleapis.com/maps/api/place/details/json'
}
export default URL
